import { render } from "./UiSwitcher.vue?vue&type=template&id=fbad7710&scoped=true&ts=true"
import script from "./UiSwitcher.vue?vue&type=script&lang=ts"
export * from "./UiSwitcher.vue?vue&type=script&lang=ts"

import "./UiSwitcher.vue?vue&type=style&index=0&id=fbad7710&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbad7710"]])

export default __exports__